import { Formik } from 'formik';
import React from 'react';

import { makeStyles } from '@material-ui/core/styles';

import DataMap from 'components/DataMap/DataMap';

import { numberWithCommas } from 'utils/lib';

const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
  },
  adminMap: {
    flex: 1,
    minHeight: '700px',
    display: 'flex',
    flexDirection: 'column',
  },
  countsSummary: {
    marginTop: '20px',
    padding: '20px 24px',
    borderRadius: '8px',
    backgroundColor: theme.palette.offWhite.main,
    color: theme.palette.darkGray.main,
  },
  countsSummaryHeader: {
    margin: 0,
    fontSize: '18px',
    fontWeight: 700,
    lineHeight: '24px',
    color: theme.palette.black.main,
  },
  countsSummaryText: {
    margin: '8px 0 0',
    fontSize: '14px',
    lineHeight: '20px',
  },
  countsList: {
    margin: '16px 0 0',
    padding: 0,
    listStyle: 'none',
    display: 'flex',
    flexWrap: 'wrap',
    gap: '12px',
  },
  countsListItem: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: '10px',
    padding: '10px 14px',
    borderRadius: '999px',
    backgroundColor: theme.palette.white.main,
    border: `1px solid ${theme.palette.gray.light}`,
    fontSize: '14px',
    lineHeight: '22px',
  },
  countsListLabel: {
    padding: '4px 10px',
    borderRadius: '999px',
    backgroundColor: theme.palette.orange.main,
    color: theme.palette.white.main,
    fontWeight: 700,
    lineHeight: '18px',
  },
  countsListValue: {
    fontWeight: 600,
    color: theme.palette.black.main,
  },
}));

const APNCountsDataMapView = () => {
  const classes = useStyles();

  const [apnsTotalSelectedCount, setApnsTotalSelectedCount] = React.useState(0);
  const [apnsTotalInAreaCount, setApnsTotalInAreaCount] = React.useState(0);
  const [apnSelectedCounts, setApnSelectedCounts] = React.useState([]);
  const [, setApnAvailableCounts] = React.useState([]);
  const hasCountsToShow = apnSelectedCounts.length > 0 || apnsTotalSelectedCount > 0 || apnsTotalInAreaCount > 0;

  return (
    <div className={classes.root}>
      <div className={classes.adminMap}>
        <Formik
          initialValues={{}}
          onSubmit={null}
          validationSchema={{}}
        >
          {() => (
            <DataMap
              apnSelectedCounts={apnSelectedCounts}
              setApnSelectedCounts={setApnSelectedCounts}
              setApnAvailableCounts={setApnAvailableCounts}
              setApnsTotalSelectedCount={setApnsTotalSelectedCount}
              setApnsTotalInAreaCount={setApnsTotalInAreaCount}
              generateCostsButtonText="Get APN Count"
              allowDataSelection
              filtersModalOptions={{
                disableEventTypeSelector: false,
              }}
            />
          )}
        </Formik>
      </div>

      {hasCountsToShow && (
        <div className={classes.countsSummary}>
          <h3 className={classes.countsSummaryHeader}>APN Count Results</h3>
          <p className={classes.countsSummaryText}>
            {apnsTotalSelectedCount < apnsTotalInAreaCount
              ? `${numberWithCommas(apnsTotalSelectedCount)} available APNs out of ${numberWithCommas(apnsTotalInAreaCount)} total APNs in the selected area.`
              : `${numberWithCommas(apnsTotalSelectedCount)} APNs found in the selected area.`}
          </p>
          {apnSelectedCounts.length > 0 && (
            <ul className={classes.countsList}>
              {apnSelectedCounts.map(({ name, count }) => (
                <li key={name} className={classes.countsListItem}>
                  <span className={classes.countsListLabel}>{name}</span>
                  <span className={classes.countsListValue}>{`${numberWithCommas(count)} APNs`}</span>
                </li>
              ))}
            </ul>
          )}
        </div>
      )}
    </div>
  );
};

export default APNCountsDataMapView;
